module.exports = {"data":{"firstSectionImage":{"sizes":{"aspectRatio":1.7777777777777777,"src":"/static/cover-img-e75d30fd478146ac4961d184a4895a89-8a70b.jpg","srcSet":"/static/cover-img-e75d30fd478146ac4961d184a4895a89-7fcf9.jpg 256w,\n/static/cover-img-e75d30fd478146ac4961d184a4895a89-c349b.jpg 512w,\n/static/cover-img-e75d30fd478146ac4961d184a4895a89-8a70b.jpg 1024w,\n/static/cover-img-e75d30fd478146ac4961d184a4895a89-b247a.jpg 1536w,\n/static/cover-img-e75d30fd478146ac4961d184a4895a89-46c7a.jpg 1920w","sizes":"(max-width: 1024px) 100vw, 1024px"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 363
// module chunks = 142629428675168